import ModalPopUp from "../common/ModalPopUp";

import { useDispatch, useSelector } from "react-redux";
import { Popconfirm, Tooltip } from "antd";
import moment from "moment";
import React, { useEffect, useRef } from "react";

import "@/assets/css/qr-code-print.scss";
import QRCode from "react-qr-code";
import { useReactToPrint } from "react-to-print";

import { ACTION_BTN_HOVER_CLR } from "@/Constants/common";
import { updateQRCode, toggleQrCodeModal } from "@/reducers/clientcommon";
import { TOOLTIPTEXT } from "@/utilities/CommonText";

import { apiEncrypt } from "../../utilities/keyEncryption";
import ActionIcons from "../common/client/ActionIcons";
import ApplocumBlueLogoIcon from "../Icons/ApplocumBlueLogoIcon";
import ApplocumLogoIcon from "../Icons/ApplocumLogoIcon";
import { LocationIcon } from "../Icons/LocationIcon";
import { PhoneCallIcon } from "../Icons/PhoneCallIcon";
import QrCodeIcon from "../Icons/QrCodeIcon";
import { RejectIcon } from "../Icons/RejectIcon";

const QrCodeModal = () => {
  const { session } = useSelector((state) => state.session);
  const { showQrCodeModal, clientQrCode, clientQrCodeUpdatedAt } = useSelector(
    (state) => state.clientCommon,
  );
  const { user } = useSelector((state) => state.clientProfile);
  const componentRef = useRef();
  const width = 500;
  const height = 500;

  const getBASE64 = () => {
    const svg = document.querySelector(".qr-code-wrapper svg");
    let myCanvas = document.createElement("canvas");
    myCanvas.current = document.body.appendChild(myCanvas);
    myCanvas.current.width = width;
    myCanvas.current.height = height;
    let imgSrc = `data:image/svg+xml;base64,${btoa(svg.outerHTML)}`;

    let image = new Image();
    image.src = imgSrc;
    image.onload = function () {
      myCanvas.current.getContext("2d").drawImage(image, 0, 0, width, height);
      let a = document.createElement("a");
      a.download = "qr-code.png";
      a.href = myCanvas.current.toDataURL("image/png");
      a.click();
    };
  };

  const dispatch = useDispatch();

  useEffect(() => {
    return () => {
      dispatch(toggleQrCodeModal(false));
    };
  }, []);
  const handleClose = () => {
    dispatch(toggleQrCodeModal(false));
  };
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    contentRef: componentRef,
    documentTitle: "QR Code",
  });

  const getQRValue = () => {
    let qrValue = {
      client: apiEncrypt(session.client_id),
      qr_key: apiEncrypt(session.qr_code_key),
    };
    return JSON.stringify(qrValue);
  };
  return (
    <ModalPopUp
      show={showQrCodeModal}
      onClose={() => {
        handleClose();
      }}
      panelClass="!w-full !max-w-[560px] !mb-0 h-auto"
      panelContainerClass="flex justify-center items-center"
    >
      <div className="grid">
        <div className="static top-0 mb-2 flex items-center justify-between bg-white pb-1">
          <h3 className="text-[24px] font-semibold leading-[normal] text-black">
            QR Code
          </h3>
          <div className="flex gap-5">
            <div className="flex h-[40px] cursor-pointer overflow-hidden rounded-lg bg-grey [&>*:last-child]:border-r-0 [&>*]:grid [&>*]:w-[56px] [&>*]:place-items-center [&>*]:border-0 [&>*]:border-r [&>*]:border-r-[#E5E6E9] [&>*]:text-txtColor">
              <Popconfirm
                description={
                  <>
                    <div className="max-w-[300px] p-4">
                      <p className="text-[16px] font-semibold leading-[normal] text-black">
                        Are you sure you want to refresh the QR code?
                      </p>
                    </div>
                  </>
                }
                okButtonProps={{
                  className:
                    "bg-primary text-white border !border-primary hover:!bg-white hover:!text-primary",
                }}
                cancelButtonProps={{
                  className:
                    "bg-white text-primary border !border-primary hover:!bg-primary hover:!text-white",
                }}
                okText="Yes"
                cancelText="No"
                icon={null}
                onConfirm={() => {
                  dispatch(updateQRCode());
                }}
              >
                <Tooltip title={TOOLTIPTEXT.refresh}>
                  <div className={`group ${ACTION_BTN_HOVER_CLR.yellow}`}>
                    <ActionIcons isLoading={false} type={"refresh"} />
                  </div>
                </Tooltip>
              </Popconfirm>
              <Tooltip title={TOOLTIPTEXT.print}>
                <div
                  className={`group ${ACTION_BTN_HOVER_CLR.green}`}
                  onClick={() => {
                    handlePrint();
                  }}
                >
                  <ActionIcons isLoading={false} type={"print"} />
                </div>
              </Tooltip>
              <Tooltip title={TOOLTIPTEXT.download}>
                <button
                  className={`group ${ACTION_BTN_HOVER_CLR.lightBlue}`}
                  // download
                  onClick={() => {
                    getBASE64();
                  }}
                >
                  <ActionIcons isLoading={false} type={"download"} />
                </button>
              </Tooltip>
            </div>
            <button
              onClick={() => {
                handleClose();
              }}
              className="text-red outline-none ring-0"
            >
              <RejectIcon />
            </button>
          </div>
        </div>
        <div className="relative">
          {clientQrCodeUpdatedAt ? (
            <div className="text-right text-[14px] font-medium text-black">
              Last Updated At :{" "}
              <span className="font-[16px]">
                {moment(clientQrCodeUpdatedAt, "YYYY-MM-DD HH:mm:ss").format(
                  "DD/MM/YYYY HH:mm",
                )}
              </span>
            </div>
          ) : null}
          <div
            ref={componentRef}
            className="qr-print-container overflow-hidden"
          >
            <div className="print-only">
              <ApplocumLogoIcon
                cls={
                  "text-primary opacity-5 absolute w-1/2 h-[100px] right-0 top-[0%] bg-logo"
                }
              />
            </div>
            <div className="print-only">
              <div className="flex justify-between">
                <h4 className="text-[30px] font-medium capitalize text-primary">
                  {user.client_branch_name}
                </h4>
                <ApplocumBlueLogoIcon />
              </div>
            </div>
            <div className="print-only">
              <div className="list-design mt-10 flex">
                <ul>
                  <li>
                    Scan the QR Code using the clock in/out function{" "}
                    <QrCodeIcon cls={"ml-3 mt-1"} />
                  </li>

                  <li>This will confirm your shift clock-in time</li>
                  <li>
                    When leaving, repeat the scanning process to confirm your
                    shift <br /> clock-out time to calculate the total hours
                    worked for the day.
                  </li>
                </ul>
              </div>
            </div>
            <div className="qr-code-wrapper">
              {/* <img src={clientQrCode} alt="qr code" /> */}
              <QRCode
                value={getQRValue()}
                className="h-full max-h-[500px] w-full max-w-[500px] bg-white p-2"
              />
            </div>
            <div className="print-only print-qr-footer items-top flex justify-between border-t border-t-bodyText pt-[14px]">
              <div className="flex grow items-start">
                <LocationIcon
                  cls={"text-primary min-w-[24px] h-[24px] gap-3"}
                />
                <p className="text-[20px] font-medium leading-[24px] text-black">
                  {user.client_address}
                </p>
              </div>
              <div className="flex items-start">
                <PhoneCallIcon cls={"text-primary min-w-[24px] gap-3 mt-1"} />
                <p className="text-[20px] font-medium text-black">
                  {user.client_phone_number}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ModalPopUp>
  );
};

export default QrCodeModal;
